import { PageLayout } from "@/components/site/PageLayout";
import { QuoteForm } from "@/components/site/QuoteForm";

export default function ContactPage() {
  return (
    <PageLayout eyebrow="Contact Us" title="Get in" titleAccent="touch">
      <QuoteForm />
    </PageLayout>
  );
}
